<script lang="ts" setup>
import type { HTMLAttributes } from 'vue'
import { cn } from '@/components/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <ol
    :class="
      cn('flex flex-wrap items-center gap-1.5 break-words text-sm leading-5.5 text-[#C8CCD3] sm:gap-2.5', props.class)
    "
  >
    <slot />
  </ol>
</template>
